export const isEmailCheckboxCheckable = (invoice = {}) => {
  if (!invoice.paid) {
    return true;
  } else {
    return false;
  }
};
